import { Component, OnInit } from '@angular/core';
import { LayoutComponent } from './layout/layout.component';
import { Web2ServiceService } from './services/web2-service.service';
import { RouterModule } from '@angular/router';
import { AuthService } from './services/auth.service';
import { LOGIN_OPTION } from './common/constants/common.constants';
import { ApiService } from './services/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from './services/toast.service';
import { StorageService } from './services/storage.service';
import { LoaderService } from './services/loader.service';
import { SocketService } from './services/socket.service';

@Component({
  selector: 'app-root',
  imports: [RouterModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'polymarket-frontend';
  
  constructor(
    private api: ApiService,
    private auth: AuthService,
    private toastr: ToastService,
    private loader: LoaderService,
    private storage: StorageService,
    private service: Web2ServiceService,
    private socketService: SocketService  
  ) {
    this.getCategories();
  }

  async ngOnInit() {
    /** 
     * 
     * WORKING UNDER TRIAL AND ERRORS
     */
    let sessionToken: string | null = this.auth.getSessionToken();
    if (!sessionToken) { 
      try {
        let lgnOption = this.auth.getLoginOption();
        if (!lgnOption || lgnOption.option != LOGIN_OPTION["SOCIAL_LOGIN"]) {
          let isLogged = await this.service.getAuthResult();
          if (isLogged) {
            await this.service.logout();  
          }
        }
      }
      catch(e) {
        // error -
        console.log(e);
      }
    }
    else if (sessionToken) {
          this.socketService.init();
      let userInfo: any = this.auth.getUserData();
      this.api
        .getUserProfile(userInfo.id)
        .subscribe((result: any) => {
          const hasPendingVerificationLocally = !!userInfo?.pending_email && userInfo?.is_email_verified === false;
          const mergedUserData = {
            ...userInfo,
            ...result.data
          };

          if (hasPendingVerificationLocally) {
            mergedUserData.is_email_verified = false;
            mergedUserData.pending_email = userInfo.pending_email;
            mergedUserData.email = userInfo.pending_email || userInfo.email || mergedUserData.email;
          } else {
            mergedUserData.is_email_verified = Boolean(result.data?.is_email_verified || userInfo?.is_email_verified);
          }

          this.auth.setUserData(mergedUserData);
          this.auth.isInitialProfileLoaded = true;
          this.auth.login(sessionToken);

          // Hide Reson: Not triggering enable trading modal aftern page reload
          
          // if (!this.auth.isTradeEnabled() && userInfo.user_type != "WEB2"){
          //   this.auth.sendOperationSignal("enable-trading");

          // }
        }, (error: HttpErrorResponse) => {
          console.log(error);
          if (error.status == 401) {
            this.auth.logout();
          }
          this.toastr.error("Unable to get user details. Please try again");
        })
    }
  }

  getCategories(): void {
    this.loader.show();
    this.api
      .getCategoriesList()
      .subscribe((result: any) => {
        this.loader.hide();
        this.storage.setCategoryData(result.data);
      }, (error: HttpErrorResponse) => {
        console.log(error);
      })
  }
}
